var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLightBlub = function SvgLightBlub(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 18,
    fill: "none",
    viewBox: "0 0 16 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M6.28 14.47c-.37 0-.55-.56-.55-.86-.06-2.46-2.2-2.08-2.2-4.9a4 4 0 0 1 3.95-4.04 4 4 0 0 1 3.95 4.04c0 2.82-2.14 2.44-2.2 4.9 0 .3-.23.86-.55.86h-2.4 0Z",
    clipRule: "evenodd",
    vectorEffect: "non-scaling-stroke"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M6.37 17H8.6M7.64 2.26V1M13 4.95 14.26 4M2.26 4.95 1 4",
    vectorEffect: "non-scaling-stroke"
  })));
};
export default SvgLightBlub;